var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard is-fullheight is-fullwidth columns"},[_c('div',{staticClass:"custom-box column my-3 ml-3 is-paddingless is-fullwidth"},[_c('Profile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }